const AUTH_LOOP_PATHS = new Set(['/login', '/forgot-password', '/reset-password'])

/** Safe same-app path for post-login navigation (path, optional query, optional hash). */
export function parsePostLoginRedirectPath(raw: unknown): string | null {
  const value = Array.isArray(raw) ? raw[0] : raw
  if (typeof value !== 'string') {
    return null
  }
  const trimmed = value.trim()
  if (
    !trimmed.startsWith('/') ||
    trimmed.startsWith('//') ||
    trimmed.includes('\\') ||
    /[\x00-\x1F\x7F]/.test(trimmed)
  ) {
    return null
  }

  const hashIndex = trimmed.indexOf('#')
  const hash = hashIndex >= 0 ? trimmed.slice(hashIndex) : ''
  const withoutHash = hashIndex >= 0 ? trimmed.slice(0, hashIndex) : trimmed

  const queryIndex = withoutHash.indexOf('?')
  const query = queryIndex >= 0 ? withoutHash.slice(queryIndex) : ''
  let path = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash

  path = path.replace(/\/+$/, '') || '/'

  if (path === '/' || AUTH_LOOP_PATHS.has(path.toLowerCase())) {
    return null
  }

  return `${path}${query}${hash}`
}

export function loginPathWithRedirect(redirectPath: string): string {
  return `/login?redirect=${encodeURIComponent(redirectPath)}`
}
